export default {
  title: 'If you see \'drkegel-plan.com/bill\' on your billing statement',
  subtitle: 'drkegel-plan.com/bill appears on your billing statement when you subscribe to Dr. Kegel Plan for Improving Men\'s Sexual Health. It also appears when the subscription renews.',
  stepsTitle: 'How to see what you were charged for',
  firstStep: 'Search your email for the words "kegel" or "kegel plan".',
  secondStep: 'Look for a receipt that matches the amount you see on your billing statement.',
  thirdStep: 'On the receipt, see the period and price of the subscription to the Dr. Kegel Plan',
  billingCenter: 'If you see a charge for a subscription that you no longer want, you can cancel the subscription via <a href="{link}" class="text-blue underline">Billing Center</a>.',
  whatsappText: 'I’d like help regarding the ‘drkegel-plan.com/bill’ on my billing statement'
}
